import { create } from 'zustand';

export interface Log {
  id: string;
  timestamp: Date;
  level: 'info' | 'error' | 'success' | 'warning';
  message: string;
  workflowId?: string;
}

interface LogStore {
  logs: Log[];
  addLog: (level: Log['level'], message: string, workflowId?: string) => void;
  clearLogs: () => void;
  getLogs: (workflowId?: string) => Log[];
}

export const useLogStore = create<LogStore>((set, get) => ({
  logs: [],

  addLog: (level: 'info' | 'error' | 'success' | 'warning', message: string, workflowId?: string) => {
    const newLog: Log = {
      id: Math.random().toString(36).substr(2, 9),
      timestamp: new Date(),
      level,
      message,
      workflowId,
    };
    set((state) => ({
      logs: [newLog, ...state.logs].slice(0, 100), // Keep last 100 logs
    }));
  },

  clearLogs: () => {
    set({ logs: [] });
  },

  getLogs: (workflowId?: string) => {
    const { logs } = get();
    if (!workflowId) return logs;
    return logs.filter((log) => log.workflowId === workflowId);
  },
}));
